export default "{\n    \"essentials\": \"ResQ Essentials work order\",\n    \"callback\": \"Callback\"\n}\n"